import React from 'react';
import logo from '../assets/icons/hem-logo.png';
import { AppConstant } from "../constant/AppConstant";
import '../assets/css/Footer.css';

const Footer = ({
    heroSectionRef,
    aboutUsRef,
    contactDetailsRef,
    faqRef
}: {
    heroSectionRef: React.RefObject<HTMLElement | null>;
    aboutUsRef: React.RefObject<HTMLElement | null>;
    contactDetailsRef: React.RefObject<HTMLElement | null>;
    faqRef: React.RefObject<HTMLElement | null>;
}) => {
    const scrollToSection = (sectionRef: React.RefObject<HTMLElement | null>) => {
        sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    };
    return (
        <footer className="footer-wrapper">
            <div >
                <div className="footer-content">
                    <div className="footer-about">
                        <img src={logo} alt="Logo" className="footer-about-logo" />
                        <p>
                            Order fresh groceries and delicious meals from your favorite local stores and restaurants — all in one place. Fast, easy, and reliable delivery.
                        </p>

                    </div>

                    <div className="footer-links">
                        <h4>Quick Links</h4>
                        <ul>
                            <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection(heroSectionRef); }}>Home</a></li>
                            <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection(aboutUsRef); }}>About Us</a></li>
                            <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection(contactDetailsRef); }}>Contact Us</a></li>
                            <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection(faqRef); }}>FAQ</a></li>
                        </ul>
                    </div>

                    <div className="footer-contact">
                        <h4>Contact Us</h4>
                        <ul>
                            {/* <li><i className="fa-solid fa-location-dot"></i>{AppConstant.CONTACT_ADDRESS}</li> */}
                            <li><i className="fa-solid fa-envelope"></i>{AppConstant.CONTACT_EMAIL}</li>
                            <li><i className="fa-solid fa-phone"></i>{AppConstant.CONTACT_PHONE_NUMBER}</li>
                        </ul>
                    </div>

                    <div className="footer-social">
                        <h4>Follow Us</h4>
                        <div className="social-icons">
                            {/* <a href={AppConstant.FACEBOOK_LINK}>
                                <i className="fab fa-facebook-f"></i>
                            </a> */}
                            <a href={AppConstant.INSTA_LINK}>
                                <i className="fab fa-instagram"></i>
                            </a>

                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} HEM. All rights reserved by
                        <a href="https://www.logicraftinfotech.com/"
                            target="_blank"
                            rel="noopener noreferrer"> Logicraft Infotech
                        </a></p>
                </div>

            </div>
        </footer>
    );
};

export default Footer;
